<template>
  <div class="page">
    <TopNav
        activeLv1="report"
        activeLv2=""
        @nav="onNav"
        @sub="onSub"
    />

    <div class="wrap">
      <button class="btn" @click="$router.push('/report')">{{$t('report.Return')}}</button>

      <table class="tbl">
        <colgroup>
          <col width="40" />
          <col width="294" />
          <col width="134" />
          <col width="134" />
          <col width="67" />
          <col width="67" />
          <col width="67" />
        </colgroup>
        <thead>
        <tr>
          <th>{{$t('report.No')}}</th>
          <th>{{$t('report.Info')}}</th>
          <th>{{$t('report.Bet')}}</th>
          <th>{{$t('report.Result')}}</th>
          <th>{{$t('report.Stack')}}</th>
          <th>{{$t('report.Status')}}</th>
          <th>{{$t('report.Winlose')}}</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(r, i) in rows" :key="r.id">
          <td>{{ i + 1 }}</td>

          <td class="info">
            <div class="u">{{ r.username }}</div>
            <div class="ticket">{{ r.ticketNo }}</div>
            <div>{{ r.gameName }}</div>
            <div class="time">{{ fmtDate(r.betTime) }}</div>
          </td>

          <td class="bet">
            <div class="bet1">{{ r.betDisplay }}</div>
            <div class="round">Round#{{ r.issueNo }}</div>
          </td>
          <td>{{ r.resultDisplay }}</td>
          <td class="num">{{ fmt(r.stake) }}</td>
          <td :class="r.status === 'win' ? 'win' : 'lose'">
            {{ r.status }}
          </td>
          <td class="num"
              :class="{ neg: r.winlose < 0, pos: r.winlose > 0 }">
            {{ fmt(r.winlose) }}
          </td>
        </tr>

        <tr v-if="!rows.length">
          <td colspan="7" class="empty">-</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav.vue";
import { getReportDetailApi } from "@/api/report";
import { getWalletBalanceApi } from "@/api/wallet";

export default {
  components: { TopNav },

  data() {
    return {
      rows: []
    };
  },

  computed: {
    date() {
      return this.$route.params.date;
    }
  },

  mounted() {
    this.loadDetail();
  },

  methods: {
    onNav(key) {
      if (key === "news") {
        // news = 刷新当前 lotto
        this.$router.push("/lotto");
        return;
      }
      if (key === "lotto") {
        this.$router.push("/lotto");
        return;
      }
      if (key === "lottery") {
        this.$router.push("/lottery");
        return;
      }
      if (key === "report") {
        this.$router.push("/report");
        return;
      }
      if (key === "balance") {
        this.$router.push("/balance");
        return;
      }
      if (key === "changePassword") {
        this.$router.push("/change-password");
        return;
      }
      alert("Coming soon");
    },
    onSub() {},


    async loadDetail() {
      try {
        const date = this.date;
        console.log("[report-detail] date param =", date);

        const res = await getReportDetailApi(date);

        // ✅ 兼容 http 是否 return data
        const d = res && res.data ? res.data : res;

        console.log("[report-detail] raw res =", res);
        console.log("[report-detail] data d =", d);

        this.rows = Array.isArray(d) ? d : [];
      } catch (e) {
        console.error("[report-detail] loadDetail error:", e);
        this.rows = [];
      }
    },


    fmt(v) {
      return Math.floor(Number(v || 0)).toLocaleString();
    },

    fmtDate(val) {
      if (!val) return "";
      let [d, t] = val.split(" ");
      if (d && d.includes("-")) {
        let [y, m, day] = d.split("-");
        d = `${day}/${m}/${y}`;
      }
      return t ? `${d}\n${t}` : d;
    }
  }
};
</script>

<style scoped>
.page { background:#fff; min-height:100vh; }
.wrap { padding:10px; }
.btn {
  margin-bottom:8px;
  min-width: 80px;
  width: auto;
  padding: 0 8px;
  height: 23px;
  background: #DFE8FF;
  border: 1px solid #9fb6df;
  border-radius: 4px;
  font-weight:700;
  cursor: pointer;
  color: #27448C;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.tbl { width: 803px; border-collapse:collapse; font-size:12px; table-layout: fixed; }
.tbl th {
  background:#3C5AA0; color:#FFFFFF;
  border:1px solid #9fb6df;
  padding: 0;
  height: 25px;
  font-weight:800;
}
.tbl td {
  border:1px solid #cbd7ef;
  padding: 4px 6px; 
  text-align:center;
  color: #000000;
  height: 70px;
}
.info { text-align:left; }
.u { font-weight: 400; }
.time { color: #000000; white-space: pre-wrap; line-height: 1.2; margin-top: 2px; }
.bet1 { font-weight: 800; }
.ticket { color:#0000FF; font-weight: 400; }
.round { color:#FF0000; font-weight: 400; }
.num { text-align:right; padding-right:10px; font-weight: 400; }
.win { color:#000000; font-weight: 400; }
.lose { color:#FF0000; font-weight: 400; }
.neg { color:#FF0000 !important; font-weight: 400; }
.pos { color:#000000; font-weight: 400; }
.empty { padding:20px; color:#777; }
</style>
